export default {
    workOrder_createEdit_low: "Bajo",
    workOrder_createEdit_medium: "Medio",
    workOrder_createEdit_high: "Alta",
    workOrder_createEdit_scheduledAt: "Programado En",
    workOrder_createEdit_customerLocation: "Cliente y Ubicación",
    workOrder_createEdit_type: "Tipo",
    workOrder_createEdit_formName: "Nombre del Formulario",
    workOrder_createEdit_estimatedDuration: "Duración estimada (minutos)",
    workOrder_createEdit_severity: "Severidad",
    workOrder_createEdit_driver: "Conductor",
    workOrder_createEdit_description: "Descripción",
    workOrder_createEdit_success: "Orden de trabajo guardada",
    workOrder_createEdit_unit: "Unidad",
    workOrder_createEdit_unasigned: "Sin asignar",
    workOrder_createEdit_status: "Estado",
    workOrder_createEdit_closeDate: "Fecha de Cierre",
    workOrder_createEdit_scheduledDateError: "La fecha programada es anterior a la fecha actual",
    workOrder_createEdit_formError: "Cambie el tipo de orden de trabajo e inténtelo de nuevo",
    workOrder_createEdit_dateError: "La fecha programada debe ser mayor que la fecha actual",
    workOrder_createEdit_driverError: "El conductor no está disponible en esa rango de tiempo",
};